import * as React from 'react';
import { Api } from '../../../typings/api';
import { ItemInfos, ItemLabel, ItemSubLabel, ItemStatus } from './styles';
import { Translate } from 'react-redux-i18n';
import ListItemActionButton from '../../../containers/ListItem/ActionButton';
import ListItemDownloadStatus from '../DownloadStatus';
import ListItemProposalStatus from '../ProposalStatus';
import DriveItemUtils from '../../../utils/driveItem';
import { ListItemInfosOwnProps } from '../../../containers/ListItem/Infos';

interface ListItemInfosProps extends ListItemInfosOwnProps {
	itemType: Api.AssetType | undefined;
	publicationFormat: Api.PublicationFormat | undefined;
	itemId?: number;
	proposalStats: Api.ProposalData | undefined;
	hasActionButton: boolean;
	label: string;
	isRowView: boolean;
	isActiveIcon: boolean;
	onContextualMenuHover: (e: MouseEvent) => void;
	isUpToDate: boolean;
	isUpdatable: boolean;
	isEmptyContextualMenu: boolean;
	isDownloading: boolean;
}

const ListItemInfos = (props: ListItemInfosProps) => {
	const {
		label, itemType, itemId, isUpToDate, isUpdatable, proposalStats,
		hasActionButton, isActiveIcon, isRowView, onContextualMenuHover, publicationFormat,
		isEmptyContextualMenu, isDownloading,
	} = props;

	const resolvedItemType = itemType ? itemType : Api.DriveItemType.Directory;
	const itemTypeKey = publicationFormat === Api.PublicationFormat.EPUB_PLAYLIST
		? 'fileFormat.PLAYLIST'
		: DriveItemUtils.getAssetTypeTranslationKey(resolvedItemType, publicationFormat);

	return (
		<ItemInfos isRowView={isRowView} className="ItemInfos">
			<ItemLabel isRowView={isRowView}>{label}</ItemLabel>
			<ItemSubLabel isRowView={isRowView}>
				<Translate value={itemTypeKey} />
				{proposalStats && <ListItemProposalStatus
					stats={proposalStats}
				/>}
				{publicationFormat === Api.PublicationFormat.EPUB_PREVIEW &&
					<ItemStatus>
						{'| '}<Translate value="messages.preview" />
					</ItemStatus>
				}
			</ItemSubLabel>
			<ListItemDownloadStatus
				isUpToDate={isUpToDate}
				isUpdatable={isUpdatable}
				isRowView={isRowView}
				isDownloading={isDownloading}
			/>
			{hasActionButton && !isEmptyContextualMenu && itemId && (
				<ListItemActionButton
					isRowView={isRowView}
					itemId={itemId}
					onContextualMenuHover={onContextualMenuHover}
					isActiveIcon={isActiveIcon}
				/>
			)}
		</ItemInfos>
	);
};

export default ListItemInfos;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ListItem/Infos/index.tsx